<template>
	<div class="tb-order-page">
		<div class="btnbox">
			<div v-if="selectedRows.length" class="selection-tip">
				已选 <strong>{{ selectedRows.length }}</strong> 条
			</div>
			<el-button type="primary" size="small" :disabled="syncing" @click="onSync">下载淘宝订单</el-button>
			<el-button type="primary" size="small" :disabled="making" @click="onBatchMakeOrder">向平台下单</el-button>
		</div>

		<section class="filter-card">
			<el-form v-show="filtershow" :model="form" inline size="small" class="filter-form" label-width="0" @submit.native.prevent="onSearch">
				<div class="filter-row">
					<el-form-item>
						<el-select
							v-model="form.shop_id"
							placeholder="店铺"
							filterable
							clearable
							:loading="shopLoading"
							class="filter-control"
						>
							<el-option label="全部" value="" />
							<el-option
								v-for="item in shopList"
								:key="item.id"
								:label="item.shop_name || item.mall_name || ('店铺' + item.id)"
								:value="String(item.id)"
							/>
						</el-select>
					</el-form-item>
					<el-form-item>
						<el-input v-model="form.tid" placeholder="订单号" clearable class="filter-control" @keyup.enter.native="onSearch" />
					</el-form-item>
					<el-form-item>
						<el-select v-model="form.order_status" placeholder="订单状态" clearable class="filter-control">
							<el-option label="订单状态" value="" />
							<el-option v-for="item in orderStatusOptions" :key="item.value" :label="item.label" :value="item.value" />
						</el-select>
					</el-form-item>
					<el-form-item>
						<el-select v-model="form.refund_status" placeholder="售后状态" clearable class="filter-control">
							<el-option label="全部" value="" />
							<el-option v-for="item in refundStatusOptions" :key="item.value" :label="item.label" :value="item.value" />
						</el-select>
					</el-form-item>
					<el-form-item>
						<el-select v-model="form.match_status" placeholder="下单情况" clearable class="filter-control">
							<el-option label="下单情况" value="" />
							<el-option v-for="item in matchStatusOptions" :key="item.value" :label="item.label" :value="item.value" />
						</el-select>
					</el-form-item>
					<el-form-item>
						<el-select v-model="form.platform_order_status" placeholder="平台订单状态" clearable class="filter-control">
							<el-option label="平台订单状态" value="" />
							<el-option v-for="item in platformStatusOptions" :key="item.value" :label="item.label" :value="item.value" />
						</el-select>
					</el-form-item>
					<el-form-item>
						<el-select v-model="form.match_security" placeholder="撕防伪" clearable class="filter-control">
							<el-option label="撕防伪" value="" />
							<el-option v-for="item in securityOptions" :key="item.value" :label="item.label" :value="item.value" />
						</el-select>
					</el-form-item>
					<div class="filter-actions">
						<el-button type="primary" class="btn-search" @click="onSearch">查询</el-button>
						<el-button class="btn-ghost" @click="onReset">重置</el-button>
					</div>
				</div>
			</el-form>
			<div class="filter-toggle" @click="toggleFilter">{{ filtershow ? '收起' : '展开' }}</div>
		</section>

		<el-alert
			v-if="listError"
			:title="listError"
			type="warning"
			show-icon
			:closable="false"
		/>

		<section class="table-card" ref="tableCard">
			<el-table
				ref="orderTable"
				v-loading="loading"
				:data="list"
				:height="tableHeight"
				border
				size="small"
				class="order-table"
				@selection-change="handleSelectionChange"
				@header-dragend="layoutOrderTable"
			>
				<el-table-column type="selection" width="40" align="center" header-align="center" fixed="left" />
				<el-table-column prop="retail_shop_name" label="店铺名称" align="center" header-align="center" min-width="100">
					<template slot-scope="scope">{{ displayCell(scope.row.retail_shop_name) }}</template>
				</el-table-column>
				<el-table-column label="支付时间" align="center" header-align="center" min-width="100">
					<template slot-scope="scope">{{ displayCell(scope.row.pay_time_str) }}</template>
				</el-table-column>
				<el-table-column label="订单号/预发日期" align="center" header-align="center" min-width="180">
					<template slot-scope="scope">
						<div class="combo-cell">
							<div class="combo-main tid-line" @click="onCopy(scope.row.tid)">{{ displayCell(scope.row.tid) }}</div>
							<div class="combo-sub">{{ displayCell(scope.row.match_pre_time_str) }}</div>
							<div v-if="isAutoCancel(scope.row)" class="auto-cancel-tip">（系统）</div>
						</div>
					</template>
				</el-table-column>
				<el-table-column label="商品(数量|渠道价)/防伪" align="center" header-align="center" min-width="180" class-name="goods-security-column">
					<template slot-scope="scope">
						<div class="goods-security-cell">
							<div class="goods-line">{{ formatGoodsCell(scope.row) }}</div>
							<div class="security-line">{{ formatSecurityText(scope.row) }}</div>
						</div>
					</template>
				</el-table-column>
				<el-table-column label="渠道/订单号" align="center" header-align="center" min-width="140">
					<template slot-scope="scope">
						<div class="combo-cell">
							<div class="combo-main">
								<span>{{ displayCell(scope.row.match_shop_name) }}</span>
								<el-tag v-if="scope.row.is_mandatory" size="mini" type="danger" effect="plain" class="mandatory-tag">必</el-tag>
							</div>
							<div class="combo-sub">{{ displayCell(scope.row.trade_no) }}</div>
						</div>
					</template>
				</el-table-column>
				<el-table-column prop="delivery_name" label="快递公司" align="center" header-align="center" min-width="110">
					<template slot-scope="scope">{{ displayCell(scope.row.delivery_name) }}</template>
				</el-table-column>
				<el-table-column label="渠道退货地址" align="center" header-align="center" min-width="200" class-name="return-address-column">
					<template slot-scope="scope">
						<el-popover
							v-if="hasFilled(scope.row.return_address)"
							trigger="hover"
							placement="top"
							width="360"
							popper-class="return-address-popover"
						>
							<div class="return-address-popover__content">{{ scope.row.return_address }}</div>
							<el-button type="text" size="mini" @click="onCopy(scope.row.return_address, '已复制退货地址')">复制</el-button>
							<div slot="reference" class="return-address-cell">{{ scope.row.return_address }}</div>
						</el-popover>
						<span v-else class="cell-empty">-</span>
					</template>
				</el-table-column>
				<el-table-column label="下单情况" align="center" header-align="center" min-width="120">
					<template slot-scope="scope">
						<div class="status-cell">
							<span
								v-if="scope.row.match_status_str"
								class="status-tag"
								:class="'status-tag--' + matchTagType(scope.row)"
							>{{ scope.row.match_status_str }}</span>
							<span v-else class="cell-empty">-</span>
							<div v-if="scope.row.err_msg" class="err-msg">{{ scope.row.err_msg }}</div>
						</div>
					</template>
				</el-table-column>
				<el-table-column label="平台订单状态" align="center" header-align="center" min-width="110">
					<template slot-scope="scope">
						<span
							v-if="scope.row.platform_order_status_str"
							class="status-tag"
							:class="'status-tag--' + platformTagType(scope.row)"
						>{{ scope.row.platform_order_status_str }}</span>
						<span v-else class="cell-empty">-</span>
					</template>
				</el-table-column>
				<el-table-column label="此单盈利" align="center" header-align="center" min-width="110">
					<template slot-scope="scope">
						<span :class="{ 'profit-negative': isProfitNegative(scope.row) }">{{ formatProfit(scope.row) }}</span>
					</template>
				</el-table-column>
				<el-table-column label="免费退货比/超额扣款" align="center" header-align="center" min-width="150">
					<template slot-scope="scope">{{ formatReturnRate(scope.row) }}</template>
				</el-table-column>
				<el-table-column label="订单金额(淘宝|平台)" align="center" header-align="center" min-width="150">
					<template slot-scope="scope">
						<span>{{ displayCell(scope.row.goods_amount || scope.row.payment) }}</span>/<span>{{ displayCell(scope.row.platform_amount || scope.row.match_price) }}</span>
					</template>
				</el-table-column>
				<el-table-column label="收件人姓名" align="center" header-align="center" min-width="110">
					<template slot-scope="scope">{{ displayCell(scope.row.receiver_name) }}</template>
				</el-table-column>
				<el-table-column label="收件人电话" align="center" header-align="center" min-width="120">
					<template slot-scope="scope">{{ displayCell(scope.row.receiver_mobile) }}</template>
				</el-table-column>
				<el-table-column label="收件人行政区" align="center" header-align="center" min-width="160">
					<template slot-scope="scope">{{ joinArea(scope.row) }}</template>
				</el-table-column>
				<el-table-column label="订单状态" align="center" header-align="center" min-width="110">
					<template slot-scope="scope">{{ displayCell(scope.row.order_status_str) }}</template>
				</el-table-column>
				<el-table-column
					label="售后状态"
					align="center"
					header-align="center"
					width="72"
					min-width="72"
					label-class-name="refund-status-column"
					class-name="refund-status-column"
					:fixed="refundStatusFixed ? 'right' : false"
				>
					<template slot-scope="scope">
						<div class="status-text-4">{{ displayCell(scope.row.refund_status_str) }}</div>
						<div v-if="isAutoCancel(scope.row)" class="auto-cancel-tip">已退款自动取消</div>
					</template>
				</el-table-column>
				<el-table-column label="平台快递金额" align="center" header-align="center" min-width="110">
					<template slot-scope="scope">{{ displayCell(scope.row.match_delivery_price) }}</template>
				</el-table-column>
				<el-table-column label="买家留言" align="center" header-align="center" min-width="160" show-overflow-tooltip>
					<template slot-scope="scope">{{ displayCell(scope.row.buyer_message || scope.row.buyer_memo) }}</template>
				</el-table-column>
				<el-table-column label="创建时间" align="center" header-align="center" min-width="100">
					<template slot-scope="scope">{{ displayCell(scope.row.create_time_str) }}</template>
				</el-table-column>
				<el-table-column label="操作" align="center" header-align="center" fixed="right" width="140">
					<template slot-scope="scope">
						<div class="operation_i">
							<div>
								<span @click="onOpenMatch(scope.row)">匹配渠道</span>
							</div>
							<div>
								<span @click="onOpenStyle(scope.row)">修改款号</span>
							</div>
							<div>
								<span class="op-fill-receiver" @click="onOpenFillReceiver(scope.row)">补全地址</span>
							</div>
							<div v-if="canMake(scope.row)">
								<span :class="{ 'is-disabled': making }" @click="!making && onMakeOrder([scope.row])">转单</span>
							</div>
							<div v-if="canRematch(scope.row)">
								<span :class="{ 'is-disabled': rematchingId == scope.row.id }" @click="rematchingId != scope.row.id && onRematch(scope.row)">重匹配</span>
							</div>
						</div>
					</template>
				</el-table-column>
			</el-table>
		</section>

		<section class="pager-card">
			<el-pagination
				background
				layout="total, sizes, prev, pager, next, jumper"
				:page-sizes="[20, 30, 50]"
				:current-page.sync="page"
				:page-size.sync="pageSize"
				:total="total"
				@current-change="fetchList"
				@size-change="onPageSizeChange"
			/>
		</section>

		<el-dialog title="匹配渠道" :visible.sync="matchVisible" width="90%" :before-close="onCloseMatch" :close-on-click-modal="false">
			<div class="info">
				<div class="h4">订单信息</div>
				<div class="block">
					<div>订单号:<span>{{ checkval.tid }}</span></div>
					<div>支付时间:<span>{{ checkval.pay_time_str }}</span></div>
					<div>订单金额:<span>{{ checkval.goods_amount || checkval.payment }}</span></div>
				</div>
				<div class="block">
					<div>收件人信息:<span>{{ checkval.receiver_name }}{{ checkval.receiver_mobile }}</span></div>
					<div>收件人地址:<span>{{ checkval.receiver_address }}</span></div>
				</div>
				<div class="block">
					<div>买家留言:<span>{{ checkval.buyer_message || checkval.buyer_memo }}</span></div>
				</div>
			</div>
			<div class="table">
				<div class="h4 table-title">
					<span>订单商品渠道信息</span>
					<span class="goods-order-meta">
						<span class="goods-meta-tag goods-meta-tag--style">
							<em>款号</em>
							<strong>{{ displayCell(checkval.style_number) }}</strong>
						</span>
						<span class="goods-meta-tag goods-meta-tag--size">
							<em>尺码</em>
							<strong>{{ displayCell(checkval.size) }}</strong>
						</span>
						<span class="goods-meta-tag goods-meta-tag--qty">
							<em>数量</em>
							<strong>{{ displayCell(checkval.num) }}</strong>
						</span>
					</span>
				</div>
				<el-table :data="checklist" style="width: 100%" border height="360" @current-change="handleMatchRowChange">
					<el-table-column label="" width="46" align="center" fixed="left">
						<template slot-scope="scope">
							<el-radio v-model="tableRadio" :label="scope.row" class="myradio"><span></span></el-radio>
						</template>
					</el-table-column>
					<el-table-column prop="shop_name" label="渠道" align="center" header-align="center" min-width="70" fixed="left" />
					<el-table-column prop="match_stock" label="库存" align="center" header-align="center" min-width="70" />
					<el-table-column
						v-for="col in deliveryColumns"
						:key="'delivery-' + col.delivery_id"
						:label="col.delivery_name"
						align="center"
						header-align="center"
						min-width="100"
						class-name="delivery-price-column"
					>
						<template slot-scope="scope">
							<span
								v-if="getDeliveryOption(scope.row, col.delivery_id)"
								class="delivery-price-cell"
								:class="{ 'delivery-price-cell--active': isDeliverySelected(scope.row, col.delivery_id) }"
								@click.stop="onSelectDelivery(scope.row, col.delivery_id)"
							>{{ getDeliveryOption(scope.row, col.delivery_id).delivery_price }}</span>
							<span v-else class="delivery-price-empty">-</span>
						</template>
					</el-table-column>
					<el-table-column prop="product_price" label="吊牌价" align="center" header-align="center" min-width="70" />
					<el-table-column prop="true_discount" label="折扣" align="center" header-align="center" min-width="70" />
					<el-table-column prop="stop_take_time" label="截单" align="center" header-align="center" min-width="70" />
					<el-table-column prop="agent_price" label="代理价(单价)" align="center" header-align="center" min-width="70" />
					<el-table-column prop="prev_send_delivery_date" label="预发" align="center" header-align="center" min-width="100" />
					<el-table-column prop="free_return_rate" label="退货比" align="center" header-align="center" min-width="70" />
					<el-table-column prop="exceed_rate_deduct" label="扣款" align="center" header-align="center" min-width="70" />
					<el-table-column prop="allocation_rate" label="配货率" align="center" header-align="center" min-width="70" />
					<el-table-column prop="on_time_rate" label="准时率" align="center" header-align="center" min-width="70" />
					<el-table-column prop="security" label="撕防伪" align="center" header-align="center" min-width="80">
						<template slot-scope="scope">{{ formatSecurityLabel(scope.row.security) }}</template>
					</el-table-column>
					<el-table-column prop="agent_price" label="综合价格" align="center" header-align="center" min-width="70" />
				</el-table>
			</div>
			<div slot="footer" class="dialog-footer">
				<el-button @click="onCloseMatch">取消</el-button>
				<el-button type="primary" :loading="matchSaving" @click="onSaveMatch">确定</el-button>
			</div>
		</el-dialog>

		<el-dialog title="修改款号" :visible.sync="styleVisible" width="650px" :before-close="onCloseStyle" :close-on-click-modal="false">
			<el-form ref="styleForm" :model="styleForm" :rules="styleRules" label-width="140px" size="small">
				<el-form-item label="淘宝订单号">
					<el-input v-model="styleForm.tid" readonly />
				</el-form-item>
				<el-form-item label="商品code|size" prop="style_number_size">
					<el-input v-model="styleForm.style_number_size" placeholder="请输入款号|尺码，例如 AWLW083|8" />
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click="onCloseStyle">关闭</el-button>
				<el-button type="primary" :loading="styleSaving" @click="onSaveStyle">保存</el-button>
			</div>
		</el-dialog>

		<el-dialog title="手动补填收件人信息" :visible.sync="fillVisible" width="650px" :before-close="onCloseFillReceiver" :close-on-click-modal="false">
			<el-form v-if="fillVisible" ref="fillForm" :model="fillForm" :rules="fillRules" label-width="100px" size="small">
				<el-form-item label="订单号">
					<el-input v-model="fillForm.tid" readonly />
				</el-form-item>
				<el-form-item label="收件人" prop="receiver_name">
					<el-input v-model="fillForm.receiver_name" placeholder="请输入收件人姓名" />
				</el-form-item>
				<el-form-item label="电话" prop="receiver_mobile">
					<el-input v-model="fillForm.receiver_mobile" placeholder="请输入收件人电话" />
				</el-form-item>
				<el-form-item label="省市区">
					<el-cascader
						v-model="fillForm.areaData"
						:props="areaProps"
						:options="regionData"
						clearable
						filterable
						placeholder="请选择省 / 市 / 区（可选）"
						class="fill-receiver-cascader"
					/>
				</el-form-item>
				<el-form-item label="详细地址" prop="receiver_address">
					<el-input v-model="fillForm.receiver_address" type="textarea" :rows="2" placeholder="街道、门牌号等详细地址" />
				</el-form-item>
			</el-form>
			<div class="fill-receiver-tip">收件人脱敏属正常现象。请到淘宝商家后台查看明文后再补全，保存后不会被定时同步覆盖。</div>
			<div slot="footer" class="dialog-footer">
				<el-button :disabled="fillSaving" @click="onCloseFillReceiver">取消</el-button>
				<el-button type="primary" :loading="fillSaving" @click="onSaveFillReceiver">确认保存</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	import { regionData } from 'element-china-area-data'
	import { getApiErrorMessage } from '@/constants/retailPlatform'
	import {
		TB_SHOP_API,
		TB_ORDER_API,
		TB_ORDER_WAIT_SEND,
		TB_ORDER_STATUS_OPTIONS,
		TB_REFUND_STATUS_OPTIONS,
		TB_MATCH_STATUS_OPTIONS,
		TB_PLATFORM_ORDER_STATUS_OPTIONS,
		TB_SECURITY_OPTIONS,
		canMakeTbOrder,
		canRematchTbOrder,
		formatTbStyleNumberSize,
		joinTbOrderIds,
		tbMatchStatusTagType,
		tbPlatformOrderStatusTagType,
		isTbOrderAutoCancel,
		formatTbOrderGood,
		formatTbMatchSecurity,
		formatTbProfitText,
		isTbProfitNegative,
		formatTbReturnRateText,
		hasTbFilledValue,
		getRequestErrorMessage,
		isRequestTimeout,
	} from '@/constants/taobaoShop'

	export default {
		name: 'TaobaoOrder',
		data() {
			return {
				shopList: [],
				shopLoading: false,
				list: [],
				loading: false,
				listError: '',
				page: 1,
				pageSize: 20,
				total: 0,
				tableHeight: 480,
				tableScrollTimer: null,
				refundStatusFixed: false,
				operationColumnWidth: 140,
				selectedRows: [],
				form: this.emptyForm(),
				orderStatusOptions: TB_ORDER_STATUS_OPTIONS,
				refundStatusOptions: TB_REFUND_STATUS_OPTIONS,
				matchStatusOptions: TB_MATCH_STATUS_OPTIONS,
				platformStatusOptions: TB_PLATFORM_ORDER_STATUS_OPTIONS,
				securityOptions: TB_SECURITY_OPTIONS,
				syncing: false,
				making: false,
				rematchingId: null,
				filtershow: true,
				refreshTimer: null,
				matchVisible: false,
				matchSaving: false,
				checkval: {},
				checklist: [],
				tableRadio: null,
				deliveryColumns: [],
				styleVisible: false,
				styleSaving: false,
				styleForm: {
					id: '',
					tid: '',
					style_number_size: '',
				},
				styleRules: {
					style_number_size: [{ required: true, message: '请输入商品code|size', trigger: 'blur' }],
				},
				fillVisible: false,
				fillSaving: false,
				regionData: [],
				areaProps: {
					value: 'label',
					label: 'label',
					children: 'children',
				},
				fillForm: {
					id: '',
					tid: '',
					receiver_name: '',
					receiver_mobile: '',
					receiver_address: '',
					areaData: [],
				},
				fillRules: {
					receiver_name: [{ required: true, message: '请输入收件人姓名', trigger: 'blur' }],
					receiver_mobile: [{ required: true, message: '请输入收件人电话', trigger: 'blur' }],
					receiver_address: [{ required: true, message: '请输入收件人地址', trigger: 'blur' }],
				},
			}
		},
		mounted() {
			this.regionData = regionData
			this.fetchShops()
			this.fetchList()
			this.$nextTick(this.calcTableHeight)
			window.addEventListener('resize', this.calcTableHeight)
		},
		beforeDestroy() {
			window.removeEventListener('resize', this.calcTableHeight)
			this.unbindOrderTableScroll()
			if (this.tableScrollTimer) {
				clearTimeout(this.tableScrollTimer)
				this.tableScrollTimer = null
			}
			if (this.refreshTimer) {
				clearTimeout(this.refreshTimer)
			}
		},
		methods: {
			emptyForm() {
				return {
					shop_id: '',
					tid: '',
					order_status: TB_ORDER_WAIT_SEND,
					refund_status: '',
					match_status: '',
					platform_order_status: '',
					match_security: '',
				}
			},
			displayCell(value) {
				if (value === 0) {
					return '0'
				}
				if (value == null || value === '') {
					return '-'
				}
				return String(value)
			},
			joinArea(row) {
				if (!row) {
					return '-'
				}
				const parts = [row.receiver_state, row.receiver_city, row.receiver_district].filter(function(item) {
					return item
				})
				return parts.length ? parts.join('/') : '-'
			},
			formatGoodsCell: formatTbOrderGood,
			formatSecurityText: formatTbMatchSecurity,
			formatProfit: formatTbProfitText,
			isProfitNegative: isTbProfitNegative,
			formatReturnRate: formatTbReturnRateText,
			hasFilled: hasTbFilledValue,
			toggleFilter() {
				this.filtershow = !this.filtershow
				this.$nextTick(this.calcTableHeight)
			},
			canMake: canMakeTbOrder,
			canRematch: canRematchTbOrder,
			matchTagType: tbMatchStatusTagType,
			platformTagType: tbPlatformOrderStatusTagType,
			isAutoCancel: isTbOrderAutoCancel,
			calcTableHeight() {
				this.$nextTick(() => {
					const card = this.$refs.tableCard
					if (!card) {
						return
					}
					const h = card.getBoundingClientRect().height
					this.tableHeight = h > 280 ? Math.floor(h) : 280
					this.layoutOrderTable()
					this.$nextTick(() => {
						this.bindOrderTableScroll()
						this.updateRefundStatusFixed()
					})
				})
			},
			layoutOrderTable() {
				this.$nextTick(() => {
					const table = this.$refs.orderTable
					if (table && typeof table.doLayout === 'function') {
						table.doLayout()
					}
				})
			},
			getRefundStatusColumnMetrics() {
				const table = this.$refs.orderTable
				if (!table || !table.$el) {
					return null
				}
				const headerTable = table.$el.querySelector('.el-table__header-wrapper > table')
				if (!headerTable) {
					return null
				}
				const target = headerTable.querySelector('thead tr th.refund-status-column')
				if (!target) {
					return null
				}
				return {
					left: target.offsetLeft,
					width: target.offsetWidth || 110,
				}
			},
			updateRefundStatusFixed() {
				const table = this.$refs.orderTable
				if (!table || !table.$el) {
					return
				}
				const bodyWrapper = table.$el.querySelector('.el-table__body-wrapper')
				if (!bodyWrapper) {
					return
				}
				const hasOverflow = bodyWrapper.scrollWidth > bodyWrapper.clientWidth + 1
				if (!hasOverflow) {
					if (this.refundStatusFixed) {
						this.refundStatusFixed = false
						this.layoutOrderTable()
					}
					return
				}
				const metrics = this.getRefundStatusColumnMetrics()
				if (!metrics) {
					return
				}
				const scrollLeft = bodyWrapper.scrollLeft
				const visibleRight = scrollLeft + bodyWrapper.clientWidth - this.operationColumnWidth
				const shouldFix = metrics.left + metrics.width > visibleRight + 1
				if (shouldFix === this.refundStatusFixed) {
					return
				}
				this.refundStatusFixed = shouldFix
				this.layoutOrderTable()
				this.$nextTick(this.updateRefundStatusFixed)
			},
			bindOrderTableScroll() {
				const table = this.$refs.orderTable
				if (!table || !table.$el) {
					return
				}
				const bodyWrapper = table.$el.querySelector('.el-table__body-wrapper')
				if (!bodyWrapper || bodyWrapper._orderScrollBound) {
					return
				}
				bodyWrapper._orderScrollBound = true
				this._orderTableBodyWrapper = bodyWrapper
				bodyWrapper.addEventListener('scroll', this.onOrderTableScroll, { passive: true })
			},
			unbindOrderTableScroll() {
				if (this._orderTableBodyWrapper) {
					this._orderTableBodyWrapper.removeEventListener('scroll', this.onOrderTableScroll)
					this._orderTableBodyWrapper._orderScrollBound = false
					this._orderTableBodyWrapper = null
				}
			},
			onOrderTableScroll() {
				if (this.tableScrollTimer) {
					clearTimeout(this.tableScrollTimer)
				}
				this.tableScrollTimer = setTimeout(() => {
					this.tableScrollTimer = null
					this.updateRefundStatusFixed()
				}, 16)
			},
			fetchShops() {
				this.shopLoading = true
				this.$axios.get(TB_SHOP_API.shopList).then((res) => {
					if (res.data.code == 0) {
						this.shopList = (res.data.data && res.data.data.list) || []
					} else {
						this.shopList = []
					}
				}).catch((err) => {
					console.log(err)
					this.shopList = []
				}).finally(() => {
					this.shopLoading = false
				})
			},
			buildListParams() {
				const params = {
					page: this.page,
					page_size: this.pageSize,
				}
				if (this.form.shop_id) {
					params.shop_id = this.form.shop_id
				}
				const tid = String(this.form.tid || '').trim()
				if (tid) {
					params.tid = tid
				}
				if (this.form.order_status) {
					params.order_status = this.form.order_status
				}
				if (this.form.refund_status) {
					params.refund_status = this.form.refund_status
				}
				if (this.form.match_status !== '' && this.form.match_status != null) {
					params.match_status = this.form.match_status
				}
				if (this.form.platform_order_status !== '' && this.form.platform_order_status != null) {
					params.platform_order_status = this.form.platform_order_status
				}
				if (this.form.match_security !== '' && this.form.match_security != null) {
					params.match_security = this.form.match_security
				}
				return params
			},
			fetchList() {
				this.loading = true
				this.listError = ''
				this.$axios.get(TB_ORDER_API.list, { params: this.buildListParams() }).then((res) => {
					if (res.data.code == 0) {
						const data = res.data.data || {}
						this.list = data.list || []
						this.total = Number(data.total != null ? data.total : data.count) || 0
						this.$nextTick(this.calcTableHeight)
					} else {
						this.list = []
						this.total = 0
						this.listError = getApiErrorMessage(res, '获取淘宝订单失败')
					}
				}).catch((err) => {
					console.log(err)
					this.list = []
					this.total = 0
					this.listError = getRequestErrorMessage(err, '获取淘宝订单失败')
				}).finally(() => {
					this.loading = false
				})
			},
			onSearch() {
				this.page = 1
				this.fetchList()
			},
			onReset() {
				this.form = this.emptyForm()
				this.page = 1
				this.fetchList()
			},
			onPageSizeChange(size) {
				this.page = 1
				this.pageSize = size
				this.fetchList()
			},
			handleSelectionChange(rows) {
				this.selectedRows = rows || []
			},
			requireShop() {
				if (!this.form.shop_id) {
					this.$message.warning('请先选择店铺')
					return false
				}
				return true
			},
			scheduleRefresh() {
				if (this.refreshTimer) {
					clearTimeout(this.refreshTimer)
				}
				this.refreshTimer = setTimeout(() => {
					this.fetchList()
				}, 3000)
			},
			onSync() {
				if (!this.requireShop()) {
					return
				}
				this.syncing = true
				this.$axios.post(TB_ORDER_API.sync, {
					retail_shop_id: Number(this.form.shop_id),
				}).then((res) => {
					if (res.data.code == 0) {
						this.$message.success(res.data.message || res.data.msg || '同步任务已提交，请稍后刷新列表')
						this.fetchList()
					} else {
						this.$message.warning(getApiErrorMessage(res, '同步进行中，请稍后再试'))
					}
				}).catch((err) => {
					console.log(err)
					if (isRequestTimeout(err)) {
						this.$message.warning('同步时间较长，后台仍在处理，请稍后刷新列表')
						this.fetchList()
						return
					}
					this.$message.error(getRequestErrorMessage(err, '同步失败'))
				}).finally(() => {
					this.syncing = false
				})
			},
			onBatchMakeOrder() {
				if (!this.selectedRows.length) {
					this.$message.warning('请先勾选要转单的订单')
					return
				}
				const rows = this.selectedRows.filter(canMakeTbOrder)
				if (!rows.length) {
					this.$message.warning('勾选的订单中没有可转单的记录（需可下单且待发货）')
					return
				}
				this.onMakeOrder(rows)
			},
			onMakeOrder(rows) {
				const ids = joinTbOrderIds(rows)
				if (!ids) {
					this.$message.warning('缺少订单主键，无法转单')
					return
				}
				this.making = true
				this.$axios.post(TB_ORDER_API.makeOrder, { ids: ids }).then((res) => {
					if (res.data.code == 0) {
						this.$message.success(res.data.message || res.data.msg || '已提交转单任务')
						this.fetchList()
						this.scheduleRefresh()
					} else {
						this.$message.error(getApiErrorMessage(res, '转单提交失败'))
					}
				}).catch((err) => {
					console.log(err)
					this.$message.error(getRequestErrorMessage(err, '转单提交失败'))
				}).finally(() => {
					this.making = false
				})
			},
			onRematch(row) {
				const ids = joinTbOrderIds([row])
				if (!ids) {
					this.$message.warning('缺少订单主键，无法重匹配')
					return
				}
				this.rematchingId = row.id
				this.$axios.post(TB_ORDER_API.rematch, { ids: ids }).then((res) => {
					if (res.data.code == 0) {
						this.$message.success(res.data.message || res.data.msg || '重匹配完成')
						this.fetchList()
					} else {
						this.$message.error(getApiErrorMessage(res, '重匹配失败'))
					}
				}).catch((err) => {
					console.log(err)
					this.$message.error(getRequestErrorMessage(err, '重匹配失败'))
				}).finally(() => {
					this.rematchingId = null
				})
			},
			plainReceiverValue(value) {
				const text = value == null ? '' : String(value)
				if (!text || text.indexOf('*') !== -1) {
					return ''
				}
				return text
			},
			formatSecurityLabel(n) {
				if (n == 2) {
					return '撕防伪'
				}
				if (n == 3) {
					return '不撕防伪'
				}
				return ''
			},
			onOpenMatch(row) {
				if (!row || !row.id) {
					return
				}
				this.checkval = row
				this.$axios.get(TB_ORDER_API.match, { params: { id: row.id } }).then((res) => {
					if (res.data.code != 0) {
						this.$message.error(getApiErrorMessage(res, '获取匹配渠道失败'))
						return
					}
					const data = res.data.data
					this.checklist = Array.isArray(data) ? data : ((data && data.list) || [])
					this.restoreMatchSelection(this.checklist, row)
					this.deliveryColumns = this.buildDeliveryColumns(this.checklist)
					this.matchVisible = true
				}).catch((err) => {
					console.log(err)
					this.$message.error(getRequestErrorMessage(err, '获取匹配渠道失败'))
				})
			},
			onCloseMatch() {
				this.matchVisible = false
				this.checkval = {}
				this.checklist = []
				this.tableRadio = null
				this.deliveryColumns = []
				this.matchSaving = false
			},
			restoreMatchSelection(list, order) {
				let selectedRow = null
				const self = this
				;(list || []).forEach(function(row) {
					const configs = row && row.delivery_config ? row.delivery_config : []
					const firstDelivery = configs[0]
					let checked = firstDelivery ? firstDelivery.delivery_id : ''
					if (self.isMatchedChannelRow(row, order)) {
						const savedDelivery = self.findSavedDelivery(configs, order)
						if (savedDelivery) {
							checked = savedDelivery.delivery_id
						}
						selectedRow = row
					}
					self.$set(row, 'checked', checked)
				})
				this.tableRadio = selectedRow
			},
			isMatchedChannelRow(row, order) {
				if (!row || !order) {
					return false
				}
				if (order.match_shop_id != null && order.match_shop_id !== '' && row.shop_id == order.match_shop_id) {
					return true
				}
				if (order.match_shop_name && row.shop_name && String(order.match_shop_name) === String(row.shop_name)) {
					return true
				}
				return false
			},
			findSavedDelivery(configs, order) {
				if (!configs || !configs.length || !order) {
					return null
				}
				const savedId = order.match_delivery_id
				if (savedId != null && savedId !== '') {
					for (let i = 0; i < configs.length; i++) {
						if (configs[i].delivery_id == savedId) {
							return configs[i]
						}
					}
				}
				if (order.delivery_name) {
					for (let j = 0; j < configs.length; j++) {
						if (String(configs[j].delivery_name) === String(order.delivery_name)) {
							return configs[j]
						}
					}
				}
				return null
			},
			buildDeliveryColumns(list) {
				const columns = []
				const seen = {}
				;(list || []).forEach(function(row) {
					const configs = row && row.delivery_config ? row.delivery_config : []
					configs.forEach(function(item) {
						if (!item || item.delivery_id == null || item.delivery_id === '') {
							return
						}
						const key = String(item.delivery_id)
						if (seen[key]) {
							return
						}
						seen[key] = true
						columns.push({
							delivery_id: item.delivery_id,
							delivery_name: item.delivery_name || String(item.delivery_id),
						})
					})
				})
				return columns
			},
			getDeliveryOption(row, deliveryId) {
				if (!row || !row.delivery_config || !row.delivery_config.length) {
					return null
				}
				for (let i = 0; i < row.delivery_config.length; i++) {
					if (row.delivery_config[i].delivery_id == deliveryId) {
						return row.delivery_config[i]
					}
				}
				return null
			},
			isDeliverySelected(row, deliveryId) {
				return !!(this.tableRadio === row && row && row.checked == deliveryId)
			},
			onSelectDelivery(row, deliveryId) {
				if (!row || !this.getDeliveryOption(row, deliveryId)) {
					return
				}
				this.$set(row, 'checked', deliveryId)
				this.tableRadio = row
			},
			handleMatchRowChange(curRow) {
				this.tableRadio = curRow
			},
			onSaveMatch() {
				if (!this.tableRadio) {
					this.$message.warning('请选择一条渠道')
					return
				}
				const row = this.tableRadio
				let deliveryPrice = ''
				;(row.delivery_config || []).forEach((item) => {
					if (item.delivery_id == row.checked) {
						deliveryPrice = item.delivery_price
					}
				})
				this.matchSaving = true
				this.$axios.post(TB_ORDER_API.matchSave, {
					id: this.checkval.id,
					shop_id: row.shop_id,
					delivery_id: row.checked,
					prev_send_delivery_time: row.prev_send_delivery_time,
					agent_price: row.agent_price,
					security: row.security,
					delivery_price: deliveryPrice,
				}).then((res) => {
					if (res.data.code == 0) {
						this.$message.success(res.data.message || res.data.msg || '匹配渠道保存成功')
						this.onCloseMatch()
						this.fetchList()
					} else {
						this.$message.error(getApiErrorMessage(res, '保存匹配失败'))
					}
				}).catch((err) => {
					console.log(err)
					this.$message.error(getRequestErrorMessage(err, '保存匹配失败'))
				}).finally(() => {
					this.matchSaving = false
				})
			},
			onOpenStyle(row) {
				this.styleForm = {
					id: row.id,
					tid: row.tid || '',
					style_number_size: formatTbStyleNumberSize(row),
				}
				this.styleVisible = true
				this.$nextTick(() => {
					if (this.$refs.styleForm) {
						this.$refs.styleForm.clearValidate()
					}
				})
			},
			onCloseStyle() {
				this.styleVisible = false
				this.styleSaving = false
			},
			onSaveStyle() {
				this.$refs.styleForm.validate((valid) => {
					if (!valid) {
						return
					}
					this.styleSaving = true
					this.$axios.post(TB_ORDER_API.updateStylenumber, {
						id: this.styleForm.id,
						style_number_size: this.styleForm.style_number_size,
					}).then((res) => {
						if (res.data.code == 0) {
							this.$message.success(res.data.message || res.data.msg || '款号已更新')
							this.onCloseStyle()
							this.fetchList()
						} else {
							this.$message.error(getApiErrorMessage(res, '修改款号失败'))
						}
					}).catch((err) => {
						console.log(err)
						this.$message.error(getRequestErrorMessage(err, '修改款号失败'))
					}).finally(() => {
						this.styleSaving = false
					})
				})
			},
			onOpenFillReceiver(row) {
				this.fillForm = {
					id: row.id,
					tid: row.tid || '',
					receiver_name: this.plainReceiverValue(row.receiver_name),
					receiver_mobile: this.plainReceiverValue(row.receiver_mobile),
					receiver_address: this.plainReceiverValue(row.receiver_address),
					areaData: this.buildFillAreaData(row),
				}
				this.fillVisible = true
				this.$nextTick(() => {
					if (this.$refs.fillForm) {
						this.$refs.fillForm.clearValidate()
					}
				})
			},
			buildFillAreaData(row) {
				if (!row) {
					return []
				}
				const province = row.receiver_state || ''
				const city = row.receiver_city || ''
				const area = row.receiver_district || ''
				if (province && city && area) {
					return [province, city, area]
				}
				return []
			},
			onCloseFillReceiver() {
				if (this.fillSaving) {
					return
				}
				this.fillVisible = false
			},
			onSaveFillReceiver() {
				this.$refs.fillForm.validate((valid) => {
					if (!valid) {
						return
					}
					const areaData = this.fillForm.areaData || []
					this.fillSaving = true
					this.$axios.post(TB_ORDER_API.fillReceiver, {
						id: this.fillForm.id,
						receiver_name: this.fillForm.receiver_name,
						receiver_mobile: this.fillForm.receiver_mobile,
						receiver_address: this.fillForm.receiver_address,
						receiver_province: areaData[0] || '',
						receiver_city: areaData[1] || '',
						receiver_area: areaData[2] || '',
					}).then((res) => {
						if (res.data.code == 0) {
							this.$message.success(res.data.message || res.data.msg || '收件人信息已补填')
							this.fillSaving = false
							this.onCloseFillReceiver()
							this.fetchList()
						} else {
							this.$message.error(getApiErrorMessage(res, '补全地址失败'))
							this.fillSaving = false
						}
					}).catch((err) => {
						console.log(err)
						this.fillSaving = false
						this.$message.error(getRequestErrorMessage(err, '补全地址失败'))
					})
				})
			},
			onCopy(text, successText) {
				if (!text) {
					return
				}
				const value = String(text)
				const tip = successText || '已复制订单号'
				if (navigator.clipboard && navigator.clipboard.writeText) {
					navigator.clipboard.writeText(value).then(() => {
						this.$message.success(tip)
					}).catch(() => {
						this.copyFallback(value, tip)
					})
					return
				}
				this.copyFallback(value, tip)
			},
			copyFallback(value, successText) {
				const input = document.createElement('input')
				input.value = value
				document.body.appendChild(input)
				input.select()
				try {
					document.execCommand('copy')
					this.$message.success(successText || '已复制订单号')
				} catch (e) {
					this.$message.warning('复制失败')
				}
				document.body.removeChild(input)
			},
		},
	}
</script>

<style scoped lang="less">
	@import '../storeTable.less';

	.tb-order-page {
		height: 100%;
		min-height: calc(100vh - 62px);
		padding: 8px 12px 0;
		box-sizing: border-box;
		background: linear-gradient(180deg, #f7f9fc 0%, #f3f5f8 100%);
		overflow: hidden;
		display: flex;
		flex-direction: column;
		gap: 8px;
	}

	.filter-card,
	.table-card,
	.pager-card {
		background: #fff;
		border-radius: 10px;
		box-shadow: 0 2px 12px rgba(15, 23, 42, 0.06);
	}

	.filter-card {
		padding: 10px 14px 0;
		flex-shrink: 0;
	}

	.filter-toggle {
		padding: 6px 0 8px;
		text-align: center;
		font-size: 12px;
		color: #909399;
		cursor: pointer;
	}

	.combo-cell {
		line-height: 1.35;
		text-align: center;
	}

	.combo-main {
		word-break: break-all;
		display: inline-flex;
		align-items: center;
		justify-content: center;
		flex-wrap: wrap;
		gap: 4px;
	}

	.mandatory-tag {
		margin: 0;
		padding: 0 4px;
		height: 16px;
		line-height: 16px;
	}

	.combo-sub {
		margin-top: 2px;
		color: #606266;
		font-size: 12px;
	}

	.goods-security-cell {
		line-height: 1.35;
		text-align: center;
	}

	.goods-line,
	.security-line {
		white-space: nowrap;
	}

	.security-line {
		color: #606266;
		font-size: 12px;
	}

	.filter-row {
		display: flex;
		flex-wrap: wrap;
		align-items: center;
		gap: 8px;
		width: 100%;
	}

	.filter-actions {
		display: flex;
		align-items: center;
		gap: 6px;
		margin-left: auto;
	}

	.btn-search {
		background: linear-gradient(135deg, #ff6b3d 0%, #ff4714 100%) !important;
		border: none !important;
	}

	.btn-ghost {
		color: #606266;
		border-color: #e4e7ed;
		background: #fafbfc;
	}

	.filter-form {
		display: block;
		width: 100%;

		.filter-row > .el-form-item {
			margin-bottom: 0;
			margin-right: 0;
		}

		.filter-control {
			width: 160px;
		}
	}

	.btnbox {
		flex-shrink: 0;
		margin-bottom: 0;
		align-items: center;
		gap: 8px;
	}

	.selection-tip {
		margin-right: auto;
		font-size: 12px;
		color: #606266;

		strong {
			color: #ff4714;
		}
	}

	.table-card {
		flex: 1;
		min-height: 0;
		padding: 0;
		overflow: hidden;
		.store-table-border();
	}

	.order-table {
		width: 100%;
	}

	.cell-sub {
		margin-top: 2px;
		color: #909399;
		font-size: 12px;
	}

	.cell-empty {
		color: #909399;
		font-size: 13px;
	}

	.tid-line {
		cursor: pointer;
		color: #303133;

		&:hover {
			color: #ff4714;
		}
	}

	.status-cell {
		line-height: 1.4;
	}

	.status-tag {
		display: inline-block;
		padding: 0 8px;
		height: 24px;
		line-height: 22px;
		font-size: 13px;
		border-radius: 4px;
		border: 1px solid transparent;
		box-sizing: border-box;
		white-space: nowrap;
		vertical-align: middle;
	}

	.status-tag--danger {
		color: #f56c6c;
		background: #fef0f0;
		border-color: #fbc4c4;
	}

	.status-tag--success {
		color: #67c23a;
		background: #f0f9eb;
		border-color: #c2e7b0;
	}

	.status-tag--warning {
		color: #e6a23c;
		background: #fdf6ec;
		border-color: #f5dab1;
	}

	.status-tag--info {
		color: #909399;
		background: #f4f4f5;
		border-color: #d3d4d6;
	}

	.status-tag--primary {
		color: #409eff;
		background: #ecf5ff;
		border-color: #b3d8ff;
	}

	.err-msg {
		margin-top: 4px;
		color: #f56c6c;
		font-size: 12px;
		line-height: 1.4;
		white-space: normal;
		word-break: break-all;
	}

	.auto-cancel-tip {
		margin-top: 4px;
		color: red;
		font-size: 12px;
	}

	.status-text-4 {
		width: 4em;
		margin: 0 auto;
		line-height: 1.35;
		word-break: break-all;
		white-space: normal;
	}

	/deep/ th.refund-status-column .cell,
	/deep/ td.refund-status-column .cell {
		white-space: normal;
		padding-left: 4px;
		padding-right: 4px;
	}

	.profit-negative {
		color: #f56c6c;
		font-weight: 600;
	}

	.return-address-cell {
		height: 48px;
		line-height: 24px;
		overflow: hidden;
		display: -webkit-box;
		-webkit-box-orient: vertical;
		-webkit-line-clamp: 2;
		word-break: break-all;
		text-align: left;
		cursor: pointer;
	}

	/deep/ td.return-address-column .cell {
		white-space: normal;
	}

	.operation_i .op-fill-receiver {
		color: #e6a23c !important;
		font-weight: 600;
	}

	.operation_i .is-disabled {
		opacity: 0.55;
		cursor: not-allowed !important;
	}

	.pager-card {
		flex-shrink: 0;
		padding: 6px 12px 8px;
		display: flex;
		justify-content: flex-end;
	}

	.h4 {
		margin-bottom: 8px;
		font-size: 14px;
		font-weight: 600;
		color: #303133;
	}

	.table-title {
		display: flex;
		align-items: center;
		justify-content: space-between;
		gap: 12px;
		margin-bottom: 10px;
	}

	.goods-order-meta {
		display: inline-flex;
		align-items: center;
		flex-wrap: wrap;
		gap: 10px;
	}

	.goods-meta-tag {
		display: inline-flex;
		align-items: center;
		gap: 8px;
		padding: 4px 12px 4px 10px;
		border-radius: 999px;
		border: 1px solid transparent;
		line-height: 20px;
		box-sizing: border-box;

		em {
			font-style: normal;
			font-size: 12px;
			font-weight: 500;
			opacity: 0.88;
		}

		strong {
			font-size: 14px;
			font-weight: 600;
		}
	}

	.goods-meta-tag--style {
		color: #2563eb;
		background: linear-gradient(135deg, #eff6ff 0%, #dbeafe 100%);
		border-color: #bfdbfe;

		em {
			color: #1d4ed8;
		}
	}

	.goods-meta-tag--size {
		color: #7c3aed;
		background: linear-gradient(135deg, #f5f3ff 0%, #ede9fe 100%);
		border-color: #ddd6fe;

		em {
			color: #6d28d9;
		}
	}

	.goods-meta-tag--qty {
		color: #ff4714;
		background: linear-gradient(135deg, #fff7ed 0%, #ffedd5 100%);
		border-color: #fdba74;

		em {
			color: #ea580c;
		}
	}

	.block {
		display: flex;
		margin-bottom: 8px;

		div {
			margin-right: 20px;
		}
	}

	.info {
		margin-bottom: 20px;
	}

	.delivery-price-cell {
		display: inline-block;
		min-width: 36px;
		padding: 2px 8px;
		line-height: 22px;
		border-radius: 2px;
		cursor: pointer;
		box-sizing: border-box;
		user-select: none;
	}

	.delivery-price-cell--active {
		color: #fff;
		background: #409eff;
	}

	.delivery-price-empty {
		color: #c0c4cc;
	}

	.fill-receiver-tip {
		margin: 0 20px 8px 100px;
		color: #909399;
		font-size: 13px;
		line-height: 1.5;
	}

	/deep/ .fill-receiver-cascader {
		width: 100%;
	}

	/deep/ .fill-receiver-cascader .el-input {
		width: 100%;
	}

	/deep/ .myradio .el-radio__label {
		display: none;
	}
</style>

<style lang="less">
.return-address-popover__content {
	max-height: 200px;
	overflow-y: auto;
	word-break: break-all;
	line-height: 1.5;
	margin-bottom: 8px;
}
</style>



// WEBPACK FOOTER //
// src/components/StoreConfig/taobao/order.vue